import { canEditProjectCard, canAddProjectCard } from "./projectBoardPermissions";
import { hasAdminAccess } from "../common/Functions";
import {
  isCompletedList,
  isEmployeeBoardUser,
} from "./boardListRules";

export const isCardAssignee = (user, card) => {
  const userId = Number(user?.id || user?.userId);
  if (!userId || !card) return false;
  const ids = card.assigneeIds || card.assignees?.map((a) => a.id || a.userId) || [];
  return ids.map(Number).includes(userId);
};

export const canEditCardContent = () => canEditProjectCard();

export const canDragCardOnBoard = () => canEditProjectCard();

/** @deprecated Use isCompletedList from boardListRules */
export const isDoneList = (list) => isCompletedList(list);

/** Employees cannot drag cards that live in the Completed list. */
export const canDragCardInList = (user, list) => {
  if (!canDragCardOnBoard()) return false;
  if (isEmployeeBoardUser(user) && isCompletedList(list)) return false;
  return true;
};

/** Employees cannot move cards into, out of, or within Completed. */
export const canEmployeeMoveCardBetweenLists = (user, sourceList, destList) => {
  if (!isEmployeeBoardUser(user)) return true;
  if (isCompletedList(sourceList) || isCompletedList(destList)) return false;
  return true;
};

/**
 * Who can add cards to a list:
 * - Admin / board owner / list owner: always
 * - If list has addCardMemberIds: only those members (list grant is enough)
 * - Otherwise: anyone with module "add card" / "create"
 */
export const canUserAddCardToList = (user, list, boardOwnerId) => {
  if (!list) return false;

  const userId = Number(user?.id || user?.userId);
  if (!userId) return false;
  if (hasAdminAccess(user)) return true;
  if (boardOwnerId && Number(boardOwnerId) === userId) return true;
  if (list.ownerId && Number(list.ownerId) === userId) return true;

  const allowedIds = (list.addCardMemberIds || []).map(Number).filter((id) => id > 0);
  if (allowedIds.length) {
    return allowedIds.includes(userId);
  }

  return canAddProjectCard();
};

export { isEmployeeBoardUser };
